import { render, staticRenderFns } from "./SoftFairVersicherungsnehmer.vue?vue&type=template&id=066e7506&"
import script from "./SoftFairVersicherungsnehmer.vue?vue&type=script&lang=js&"
export * from "./SoftFairVersicherungsnehmer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports